// Public language URLs are stable; account and family data never enter the sitemap.
export const SITE_URL = "https://vanshvriksham.com";
export const PUBLIC_PAGES = {
  "/": {
    en: ["VanshVriksham – Create Your Family Tree & Vanshavali", "Create your family tree with VanshVriksham. Connect generations, preserve family stories and photos, and explore your vanshavali in English or Hindi."],
    hi: ["वंशवृक्षम् – अपनी वंशावली और परिवार का वृक्ष बनाएं", "वंशवृक्षम् पर अपने परिवार की वंशावली बनाएं। पीढ़ियों को जोड़ें, पारिवारिक कहानियां और तस्वीरें संजोएं, और हिन्दी या अंग्रेज़ी में परिवार का वृक्ष देखें।"],
  },
  "/about": {
    en: ["About VanshVriksham – Preserve Your Family History", "Learn about VanshVriksham and how it helps families preserve their lineage, connect generations, and keep stories and photos together."],
    hi: ["वंशवृक्षम् के बारे में – परिवार का इतिहास संजोएं", "जानें कि वंशवृक्षम् कैसे परिवार की वंशावली संजोने, पीढ़ियों को जोड़ने और पारिवारिक कहानियों व तस्वीरों को साथ रखने में मदद करता है।"],
  },
  "/contact": {
    en: ["Contact VanshVriksham", "Contact the VanshVriksham team for questions, feedback, or help with your family tree."],
    hi: ["वंशवृक्षम् से संपर्क करें", "अपने परिवार के वृक्ष से जुड़े प्रश्नों, सुझावों या सहायता के लिए वंशवृक्षम् टीम से संपर्क करें।"],
  },
  "/privacy-policy": {
    en: ["Privacy Policy – VanshVriksham", "Learn what information VanshVriksham collects, how it is used and shared, and how to contact us about your privacy or account data."],
    hi: ["गोपनीयता नीति – वंशवृक्षम्", "जानें कि वंशवृक्षम् कौन-सी जानकारी एकत्र करता है, उसका उपयोग और साझा कैसे करता है, और गोपनीयता या खाते के डेटा के बारे में हमसे कैसे संपर्क करें।"],
  },
};
export function publicPage(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  const language = path === "/hi" || path.startsWith("/hi/") ? "hi" : "en";
  const base = language === "hi" ? path.slice(3) || "/" : path;
  return PUBLIC_PAGES[base] ? { base, language } : null;
}
export function languagePath(base, language) {
  return language === "hi" ? `/hi${base === "/" ? "" : base}` : base;
}
export function publicPath(base, language) { return languagePath(base, language); }
export function updateSeo(pathname) {
  const page = publicPage(pathname);
  document.querySelectorAll('[data-seo="true"]').forEach(node => node.remove());
  const add = (tag, attributes, text) => {
    const node = document.createElement(tag);
    Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, value));
    node.dataset.seo = "true";
    if (text) node.textContent = text;
    document.head.appendChild(node);
  };
  const title = page ? PUBLIC_PAGES[page.base][page.language][0] : "VanshVriksham";
  const description = page ? PUBLIC_PAGES[page.base][page.language][1] : "";
  document.title = title;
  document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  add("meta", { name: "robots", content: page ? "index,follow" : "noindex,follow" });
  if (!page) return;
  const url = SITE_URL + languagePath(page.base, page.language);
  add("link", { rel: "canonical", href: url });
  for (const language of ["en", "hi"]) add("link", { rel: "alternate", hreflang: language, href: SITE_URL + languagePath(page.base, language) });
  add("link", { rel: "alternate", hreflang: "x-default", href: SITE_URL + page.base });
  for (const [property, content] of Object.entries({ "og:type": "website", "og:site_name": "VanshVriksham", "og:title": title, "og:description": description, "og:url": url, "og:image": SITE_URL + "/banyan-tree.webp", "og:locale": page.language === "hi" ? "hi_IN" : "en_IN" })) add("meta", { property, content });
  for (const [name, content] of Object.entries({ "twitter:card": "summary_large_image", "twitter:title": title, "twitter:description": description, "twitter:image": SITE_URL + "/banyan-tree.webp" })) add("meta", { name, content });
  if (page.base === "/") add("script", { type: "application/ld+json" }, JSON.stringify({ "@context": "https://schema.org", "@type": "WebSite", name: "VanshVriksham", alternateName: "वंशवृक्षम्", url: SITE_URL + "/", inLanguage: ["en", "hi"] }));
}
